module.exports = __webpack_public_path__ + "img/top-right-corner.f0c7359f.svg";